import api from './api';

const emailService = {
  // Email Accounts
  createAccount: (accountData) => api.post('/email/accounts', accountData),
  getAccounts: () => api.get('/email/accounts'),
  getAccount: (id) => api.get(`/email/accounts/${id}`),
  updateAccount: (id, data) => api.put(`/email/accounts/${id}`, data),
  deleteAccount: (id) => api.delete(`/email/accounts/${id}`),

  // Inbox
  getInbox: (params) => api.get('/email/inbox', { params }),
  getEmail: (id) => api.get(`/email/inbox/${id}`),
  markAsRead: (id) => api.patch(`/email/inbox/${id}/read`),
  toggleFlag: (id) => api.patch(`/email/inbox/${id}/flag`),
  attachToEntity: (id, data) => api.post(`/email/inbox/${id}/attach`, data),

  // Sending
  sendEmail: (emailData) => api.post('/email/send', emailData),
  replyToEmail: (id, data) => api.post(`/email/reply/${id}`, data),

  // Sent
  getSentEmails: (params) => api.get('/email/sent', { params }),

  // Entity Integration
  getEntityEmails: (type, id) => api.get(`/email/entity/${type}/${id}`)
};

export default emailService;
